import {createFileRoute} from '@tanstack/react-router'

import OccupancyScreen from '@protected/occupancy'

export const Route = createFileRoute('/_protected/occupancy')({component: OccupancyScreen})
